import * as React from 'react';
import { useQuery } from 'react-query';
import { api } from 'services';
import type { ServiceOrderStatusType } from 'contracts/service-orders';

import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

type StatusTypeOption = {
  value: string;
  label: string;
}

type Props = {
  valueType: 'id' | 'slug';
}

export const useServiceOrderStatusTypeOptions = (props?: Props) => {
  const fetchStatus = React.useCallback(async (): Promise<StatusTypeOption[]> => {
    const { data } = await api.get<ServiceOrderStatusType[]>('/inventory/service-order-status-types');
    const valueType = props?.valueType || 'id';
    return data.map(r => ({
      value: valueType === 'id' ? r.id.toString() : r.slug,
      label: r.name,
    }));
  }, [props]);

  const { data, isLoading } = useQuery({
    queryKey: ['fetch-service-order-status-types'],
    queryFn: fetchStatus,
    refetchOnWindowFocus: false,
  });

  return {
    singleSelectOptions: data?.map(optionsMapper) || [],
    multiSelectOptions: data?.map(multiSelectorOptionsMapper) || [],
    loading: isLoading,
  };
};